import { Controller } from '@hotwired/stimulus'

export default class CreditAccountModalController extends Controller {
  static targets = [
    'continueBtn',
    'backBtn',
    'amountInput',
    'amountStepContainer',
    'paymentMethodStepContainer',
    'bankTransferDetailsStepContainer',
    'cardPaymentMethodComponent',
    'form',
  ];

  static values = {
    payinUrl: String,
    openBankingUrl: String,
    maxAmount: Number,
  }

  connect () {
    this.stepsContainers = [
      this.amountStepContainerTarget,
      this.paymentMethodStepContainerTarget,
      this.bankTransferDetailsStepContainerTarget,
    ]

    this.reset();
  }

  reset() {
    this.currentStep = 1;
    this.amountInputTarget.value = null;
    this.paymentMethod = null;
    this.showCurrentStep();
    this.enableContinueBtn();
    this.updateButtonsWording();
  }

  enableContinueBtn () {
    if (this.amountIsPositive()) {
      this.continueBtnTarget.classList.remove('disabled');
    } else {
      this.continueBtnTarget.classList.add('disabled');
    }
  }

  amountIsPositive () {
    return this.amountInputTarget.value.length && parseInt(this.amountInputTarget.value, 10) > 0;
  }

  disableSubmit(event) {
    event.preventDefault();
  }

  showCurrentStep() {
    this.stepsContainers.forEach((stepContainer) => {
      stepContainer.classList.add('d-none');
    });

    this.stepsContainers[this.currentStep - 1].classList.remove('d-none');
  }

  submit(_event) {
    if (this.currentStep === 1) {
      this.currentStep = this.currentStep + 1;
      this.disableCardPaymentMethodComponents();
      this.uncheckPaymentMethods();
      this.showCurrentStep();
      this.updateButtonsWording();
      this.continueBtnTarget.classList.add('disabled');
    } else if (this.currentStep === 2 && this.paymentMethod === 'payment_method_bank_transfer') {
      this.currentStep = this.currentStep + 1;
      this.showCurrentStep();
      this.updateButtonsWording();
    } else if (this.currentStep === 2 && this.paymentMethod === 'payment_method_credit_card') {
      this.formTarget.action = this.payinUrlValue;
      this.formTarget.submit();
    } else if (this.currentStep === 2 && this.paymentMethod === 'payment_method_open_banking') {
      this.formTarget.action = this.openBankingUrlValue;
      this.formTarget.submit();
    } else if (this.currentStep === 3) {
      $(this.element).modal('hide');
    }
  }

  disableCardPaymentMethodComponents() {
    this.cardPaymentMethodComponentTargets.forEach((component) => {
      component.querySelector('label').classList.remove('disabled');
      component.querySelector('input').disabled = false;
    });

    if (
      this.amountInputTarget.value === null ||
      parseInt(this.amountInputTarget.value, 10) <= this.maxAmountValue
    ) {
      return;
    }

    this.cardPaymentMethodComponentTargets.forEach((component) => {
      component.querySelector('label').classList.add('disabled');
      component.querySelector('input').disabled = true;
    });
  }

  uncheckPaymentMethods() {
    this.paymentMethodStepContainerTarget.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.checked = false;
    });
  }

  goToPreviousStep(_event) {
    if (this.currentStep === 1) {
      $(this.element).modal('hide');
    } else {
      this.currentStep = this.currentStep - 1;
      this.showCurrentStep();
      this.updateButtonsWording();
    }
  }

  changePaymentMethod(event) {
    this.paymentMethod = event.target.value;

    switch(this.paymentMethod) {
      case 'payment_method_open_banking':
      case 'payment_method_apple_pay':
      case 'payment_method_google_pay':
      case 'payment_method_credit_card':
        this.updateBtnWordingToCredit();
        break;
      case 'payment_method_bank_transfer':
        this.updateBtnWordingToContinue();
        break;
    }

    this.continueBtnTarget.classList.remove('disabled');
  }

  updateButtonsWording() {
    if (this.currentStep === 1) {
      this.updateBtnWordingToContinue();
      this.backBtnTarget.innerText = this.backBtnTarget.dataset.cancel;
    } else if (this.currentStep === 2) {
      this.updateBtnWordingToContinue();
      this.backBtnTarget.innerText = this.backBtnTarget.dataset.editAmount;
    } else if (this.currentStep === 3) {
      this.continueBtnTarget.innerText = this.continueBtnTarget.dataset.end;
      this.backBtnTarget.innerText = this.backBtnTarget.dataset.back;
    }
  }

  updateBtnWordingToCredit() {
    let creditWording = this.continueBtnTarget.dataset.credit;
    this.continueBtnTarget.innerText = `${creditWording} ${this.amountInputTarget.value} €`;
  }

  updateBtnWordingToContinue() {
    this.continueBtnTarget.innerText = this.continueBtnTarget.dataset.continue;
  }
}
